import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import Highlighter from 'react-highlight-words';
interface Props {
  text: string;
  query?: string;
}
export function HighlightQueryInText(t0) {
  const $ = _c(12);
  const {
    text,
    query
  } = t0;
  if (!query) {
    let t1;
    if ($[0] !== text) {
      t1 = <span>{text}</span>;
      $[0] = text;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let T0;
  let t1;
  let t2;
  if ($[2] !== query || $[3] !== text) {
    const equalisedText = text.toLowerCase();
    const equalisedQuery = query?.toLowerCase();
    T0 = Highlighter;
    t1 = equalisedText.split(" ").join("-");
    t2 = equalisedQuery.split(" ");
    $[2] = query;
    $[3] = text;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== text) {
    t3 = <T0 highlightClassName={t1} searchWords={t2} autoEscape={true} textToHighlight={text} />;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}